import _defineProperty from "/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { mapEasingToNativeEasing } from './easing.mjs';
function animateStyle(element, valueName, keyframes) {
  var _element$animate;
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    duration = _ref.duration,
    _ref$repeat = _ref.repeat,
    repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
    ease = _ref.ease,
    times = _ref.times;
  return element.animate((_element$animate = {}, _defineProperty(_element$animate, valueName, keyframes), _defineProperty(_element$animate, "offset", times), _element$animate), {
    delay: delay,
    duration: duration,
    easing: mapEasingToNativeEasing(ease),
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
export { animateStyle };